"use strict";
/**
 * @fileoverview API response body interface for customer data
 * Defines the structure returned by customer endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
